const Mode = Object.freeze({
	NAVIGATION: 'navigation',
	ACTIONABLE: 'actionable',
});

export default Mode;
